module.exports = require('./helpers/bundle-url').getBundleURL('it0sp') + "logo.c51670a8.svg";